site.ada.config = site.ada.config || {};

site.ada.config.collection = { subtree: true, childList: true };
site.ada.collectionWrapper = document.querySelector("section.collection-product");
const collectionNode = (el)=>{
  if(el.classList?.contains('product-card')) {
    return true;
  }
};

const collectionCallback = ()=> {document.dispatchEvent(new CustomEvent('bazaar:pagePanelReplaced'));};

// Event listeners go here.
document.addEventListener('bazaar:pagePanelReplaced', site.ada.outlineStars('.bv_stars_button_container svg path'));
document.addEventListener('DOMContentLoaded', site.ada.outlineStars('.bv_stars_button_container svg path'));

/*
 * MutationObserver that detects when the BazaarVoice pagination panel replaced.
 * This happens when the prev/next buttons are pressed and more reviews are loaded.
 */

if (site.ada.observer){site.ada.observer(collectionNode, collectionCallback, site.ada.collectionWrapper, site.ada.config.collection);}
